/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable @typescript-eslint/no-unused-vars */
import {
  Component,
  EventEmitter,
  Input,
  Output,
  forwardRef,
} from '@angular/core';
import {
  ControlValueAccessor,
  NG_VALUE_ACCESSOR,
  NG_VALIDATORS,
  Validator,
  AbstractControl,
  ValidationErrors,
} from '@angular/forms';

@Component({
  selector: 'sag-ui-range',
  template: `<div
    sag-ui-range-base
    [track]="track"
    [thumb]="thumb"
    [input]="input"
  >
    <div sag-ui-range-track #track>
      <span sag-ui-range-thumb sag-ui-tooltip [disabled]="disabled" #thumb></span>
    </div>
    <input
      sag-ui-range
      type="range"
      [value]="value"
      [min]="min"
      [max]="max"
      [step]="step"
      [disabled]="disabled"
      (change)="onChange($event)"
      (click)="click.emit($event)"
      (focus)="focus.emit($event)"
      (blur)="onTouched(); blur.emit($event)"
      #input
    />
  </div> `,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => RangeComponent),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => RangeComponent),
      multi: true,
    },
  ],
})
export class RangeComponent implements ControlValueAccessor, Validator {
  @Input() disabled = false;
  @Input() min = 0;
  @Input() max = 100;
  @Input() step = 1;
  @Input() value = this.min;

  
  @Output() change = new EventEmitter<Event>();
  @Output() click = new EventEmitter<Event>();
  @Output() focus = new EventEmitter<Event>();
  @Output() blur = new EventEmitter<Event>();

  onChangeEvent = (_: any) => {};
  onTouched = () => {};

  writeValue(obj: any): void {
    this.value = obj;
  }

  registerOnChange(fn: any): void {
    this.onChangeEvent = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  onChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.value = Number(input.value);
    this.onChangeEvent(this.value);
    this.change.emit(event);
  }

  validate(_: AbstractControl): ValidationErrors | null {
    return null;
  }
}
